import { useEffect, useState } from 'react';
import { Map, Marker, ZoomControl } from 'pigeon-maps';
import { maptiler } from 'pigeon-maps/providers';
import { useStore } from '../../stores/store';
import '../../common/MediaQuery/responsive-view-page.css';
import { observer } from 'mobx-react-lite';

function MapComponent() {
  const [hue, setHue] = useState(0);
  const [, setSelectedPark] = useState(null);
  const color = `hsl(${hue % 360}deg 79% 60%)`;
  const maptilerProvider = maptiler('NxeWIhPr1uFuRstUDBta', 'streets');
  const { activityStore } = useStore();
  const { selectedActivity: activity } = activityStore;

  useEffect(() => {
    const listener = (e: any) => {
      if (e.key === 'Escape') {
        setSelectedPark(null);
      }
    };
    window.addEventListener('keydown', listener);
    return () => {
      window.removeEventListener('keydown', listener);
    };
  }, []);
  const data = activity?.global_positioning_system;
  const latresult: any = data?.split(',', 2)[0];
  const lat = parseFloat(latresult);
  const longresult: any = data?.split(',', 2)[1];
  const long = parseFloat(longresult);

  return (
    <div className="map-small-screen" style={{ padding: '10px' }}>
      <Map
        provider={maptilerProvider}
        height={550}
        defaultCenter={[lat, long]}
        defaultZoom={15}
      >
        <Marker
          width={50}
          anchor={[lat, long]}
          color={color}
          onClick={() => setHue(hue + 20)}
        />
        <ZoomControl />
      </Map>
    </div>
  );
}
export default observer(MapComponent);
